import React from 'react';
import BillingPaymentPreferencesLayout from './BillingPaymentPreferencesLayout';
import BillingProvider from './BillingProvider';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import {DividerLightGreyStyled, SectionWrapperInner, SectionWrapperOuter} from '@styled';
import EditProfileNavLink from "@molecules/EditProfileNavLink";
import classNames from "classnames";

const BillingPaymentPreferencesPage = () => {
    const prevNavLink = '/my-icsc/account/edit-billing/payment-history';
    const prevNavLabel = 'Payment History';
    const nextNavLink = '/my-icsc/account/edit-billing/auto-renew';
    const nextNavLabel = 'Auto-Renew Membership';
    const navClasses = classNames({
        'd-flex': true,
        'justify-content-between': prevNavLink && nextNavLink,
        'justify-content-end': !prevNavLink && nextNavLink,
    });

    return (
        <ErrorHandler>
            <TrackPageView>
                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        <BillingProvider>
                            <BillingPaymentPreferencesLayout />
                        </BillingProvider>
                    </SectionWrapperInner>
                    <DividerLightGreyStyled className="mt-5 mb-4"/>
                    <div className={navClasses}>
                        {prevNavLink && (
                            <EditProfileNavLink type="prev" to={prevNavLink}>
                                {prevNavLabel}
                            </EditProfileNavLink>
                        )}
                        {nextNavLink && (
                            <EditProfileNavLink type="next" to={nextNavLink}>
                                {nextNavLabel}
                            </EditProfileNavLink>
                        )}
                    </div>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

BillingPaymentPreferencesPage.propTypes = {
    //
};

export default BillingPaymentPreferencesPage;
